<div
  role="group"
  class="time-input-container flex items-center min-w-0"
  [attr.aria-labelledby]="labelId"
  (focusin)="onGroupFocusIn()"
  (focusout)="onGroupFocusOut($event)"
>
  <input
    #hourInput
    type="text"
    inputmode="numeric"
    autocomplete="off"
    maxlength="2"
    aria-label="Hour"
    [disabled]="disabled"
    [value]="hourSegment()"
    class="time-input-element"
    placeholder="HH"
    (mousedown)="onNumericSegmentPointerDown($event)"
    (input)="onHourInput($event)"
    (blur)="onHourBlur()"
    (keydown)="onHourKeydown($event)"
    (paste)="onHourPaste($event)"
  />
  <span class="time-input-spacer" aria-hidden="true">:</span>
  <input
    #minuteInput
    type="text"
    inputmode="numeric"
    autocomplete="off"
    maxlength="2"
    aria-label="Minute"
    [disabled]="disabled"
    [value]="minuteSegment()"
    class="time-input-element"
    placeholder="MM"
    (mousedown)="onNumericSegmentPointerDown($event)"
    (input)="onMinuteInput($event)"
    (blur)="onMinuteBlur()"
    (keydown)="onMinuteKeydown($event)"
  />
  @if (use12Hour()) {
    <input
      #meridiemInput
      type="text"
      autocomplete="off"
      maxlength="2"
      aria-label="AM or PM"
      [disabled]="disabled"
      [value]="meridiemDisplaySegment()"
      class="time-input-element time-input-meridiem"
      placeholder="AM"
      (mousedown)="onMeridiemPointerDown($event)"
      (input)="onMeridiemInput($event)"
      (blur)="onMeridiemBlur()"
      (keydown)="onMeridiemKeydown($event)"
      (paste)="onMeridiemPaste($event)"
    />
  }
</div>
@if (timePicker()) {
  <input
    type="text"
    tabindex="-1"
    aria-hidden="true"
    class="mat-timepicker-input fleet-time-input-bridge"
    [formControl]="bridgeControl"
    [matTimepicker]="timePicker()!"
    [matTimepickerOpenOnClick]="false"
  />
}
